<template>
  <div
    v-if="post.front_container==='premium'"
    class="badge"
  ></div>
</template>
<script>
export default {
  name: 'BadgePostPremium',
  props: {
    post: {}
  }
}
</script>

<style scoped lang="scss">
div.badge{
  position: absolute;
  left: -45px;
  top: 45px;
  width: 73px;
  height: 48px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url("/img/btn/btn-premium.png");
  
  @media(max-width: 768px){
    left: -15px;
    top: 35px;
  }
}
</style>
